import { render, staticRenderFns } from "./task-tabs-tab.vue?vue&type=template&id=75556995"
import script from "./task-tabs-tab.vue?vue&type=script&lang=js"
export * from "./task-tabs-tab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports